import Cookies from "js-cookie";

export const saveCookies = (name, data, time = 0.333) => {
    Cookies.set(name, data, {
        expires: time,
        secure: true,
        sameSite: "Strict"
    });
};

export const getCookies = (name) => {
    return Cookies.get(name);
};

export const removeCookies = (name) => {
    return Cookies.remove(name);
};

